<template>
  <div id="app">
    <v-app>
      <home-header/>
      <feedback-form />
      <router-view/>
      <footer-component/>
    </v-app>
  </div>
</template>

<script>

import './assets/sass/app.scss'
import FooterComponent from '@/components/home/MainFooter.vue';
import HomeHeader from '@/components/home/HomeHeader.vue'
import FeedbackForm from '@/components/forms/FeedbackForm.vue'

export default {
  name: 'App',
  components: {
    FooterComponent,
    HomeHeader,
    FeedbackForm
  }
}
</script>
